import { render, staticRenderFns } from "./ViewOutflows.vue?vue&type=template&id=67a711cc&scoped=true"
import script from "./ViewOutflows.vue?vue&type=script&lang=js"
export * from "./ViewOutflows.vue?vue&type=script&lang=js"
import style0 from "./ViewOutflows.vue?vue&type=style&index=0&id=67a711cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a711cc",
  null
  
)

export default component.exports